import { render, staticRenderFns } from "./myphotos.vue?vue&type=template&id=2de9030e&scoped=true"
import script from "./myphotos.vue?vue&type=script&lang=js"
export * from "./myphotos.vue?vue&type=script&lang=js"
import style0 from "./myphotos.vue?vue&type=style&index=0&id=2de9030e&prod&lang=css"
import style1 from "./myphotos.vue?vue&type=style&index=1&id=2de9030e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9030e",
  null
  
)

export default component.exports